import styled from "styled-components";

const Menu = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.baseWhite};
`;

export default Menu;
